import axios from 'axios';
import { origins as originUtils, parserUtils } from 'z-js-commons';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';
import { getContextId } from '../lib/TaxonomyUtils';
import { fixExerciseStructure } from '../lib/exerciseTransformations/fixExerciseStructure';
import { handleUnauthorizedError } from '../lib/heartBeat';

export function getSpecialSubjects(filters = {}) {
    return async dispatch => {
        dispatch({
            type: types.GET_SPECIAL_SUBJECTS_LIST
        });
        const url = `${API_URL}/taxonomies/subjects/cv`;
        let params = '';

        if (filters.origins && filters.origins.length >= 1) {
            let origins = JSON.stringify(parserUtils.getElementsFromArrayByProp('id', filters.origins));
            params = `origin=${origins}`;
        } else {
            params = `origin=${JSON.stringify([originUtils.PROVE_COMUNI, originUtils.PROVE_INGRESSO, originUtils.REALTA_MODELLI])}`;
        }

        let urlToInvoke = `${url}?${params}`;
        try {
            const { data } = await axios.get(`${urlToInvoke}`, {
                withCredentials: true
            });
            dispatch({
                type: types.GET_SPECIAL_SUBJECTS_LIST_SUCCESS,
                result: data
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            if (e.response && e.response.status === 401) {
                dispatch({
                    type: types.GET_SPECIAL_SUBJECTS_LIST_UNAUTHORIZED,
                    error: 'Unauthorized'
                });
            } else {
                dispatch({
                    type: types.GET_SPECIAL_SUBJECTS_LIST_FAILURE,
                    error: e
                });
            }
        }
    };
}

export function getSpecialOrigins(filters = {}) {
    return async dispatch => {
        dispatch({
            type: types.GET_SPECIAL_ORIGINS_LIST
        });
        const url = `${API_URL}/taxonomies/origins/cv`;
        let params = `origins=${JSON.stringify([originUtils.PROVE_COMUNI, originUtils.PROVE_INGRESSO, originUtils.REALTA_MODELLI])}`;

        if (filters.subjects) {
            let subjects = JSON.stringify(parserUtils.getElementsFromArrayByProp('ids', filters.subjects));
            params = `${params}&subjects=${subjects}`;
        }

        let urlToInvoke = `${url}?${params}`;
        try {
            const { data } = await axios.get(`${urlToInvoke}`, {
                withCredentials: true
            });
            dispatch({
                type: types.GET_SPECIAL_ORIGINS_LIST_SUCCESS,
                result: data
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            if (e.response && e.response.status === 401) {
                dispatch({
                    type: types.GET_SPECIAL_ORIGINS_LIST_UNAUTHORIZED,
                    error: 'Unauthorized'
                });
            } else {
                dispatch({
                    type: types.GET_SPECIAL_ORIGINS_LIST_FAILURE,
                    error: e
                });
            }
        }
    };
}

export function getSpecialItemTypes(filters = {}) {
    return async dispatch => {
        dispatch({
            type: types.GET_SPECIAL_ITEMTYPES_LIST
        });
        const url = `${API_URL}/taxonomies/itemTypes/cv`;
        let params = '';

        if (filters.origins && filters.origins.length >= 1) {
            let origins = JSON.stringify(parserUtils.getElementsFromArrayByProp('id', filters.origins));
            params = `origin=${origins}`;
        } else {
            params = `origin=${JSON.stringify([originUtils.PROVE_COMUNI, originUtils.PROVE_INGRESSO, originUtils.REALTA_MODELLI])}`;
        }

        if (filters.subjects) {
            let subjects = JSON.stringify(parserUtils.getElementsFromArrayByProp('ids', filters.subjects));
            params = `${params}&subjects=${subjects}`;
        }

        let urlToInvoke = `${url}?${params}`;
        try {
            const { data } = await axios.get(`${urlToInvoke}`, {
                withCredentials: true
            });
            dispatch({
                type: types.GET_SPECIAL_ITEMTYPES_LIST_SUCCESS,
                result: data
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            if (e.response && e.response.status === 401) {
                dispatch({
                    type: types.GET_SPECIAL_ITEMTYPES_LIST_UNAUTHORIZED,
                    error: 'Unauthorized'
                });
            } else {
                dispatch({
                    type: types.GET_SPECIAL_ITEMTYPES_LIST_FAILURE,
                    error: e
                });
            }
        }
    };
}

export function getSpecialTaxonomy(filters = {}) {
    const url = `${API_URL}/taxonomies/contents/cv`;

    let params = '';

    if (filters.origins && filters.origins.length >= 1) {
        let origins = JSON.stringify(parserUtils.getElementsFromArrayByProp('id', filters.origins));
        params = `origin=${origins}`;
    } else {
        params = `origin=${JSON.stringify([originUtils.PROVE_COMUNI, originUtils.PROVE_INGRESSO, originUtils.REALTA_MODELLI])}`;
    }

    if (filters.subjects) {
        let subjects = JSON.stringify(parserUtils.getElementsFromArrayByProp('ids', filters.subjects));
        params = `${params}&subjects=${subjects}`;
    }

    return async dispatch => {
        dispatch({
            type: types.GET_SPECIAL_CONTENT_TAXONOMY
        });
        try {
            const { data } = await axios.get(`${url}?${params}`, { withCredentials: true });
            dispatch({
                type: types.GET_SPECIAL_CONTENT_TAXONOMY_SUCCESS,
                result: data
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.GET_SPECIAL_CONTENT_TAXONOMY_FAILURE,
                error: e
            });
        }
    };
}

export function getSpecialExercises(idList, searchTerm, isSuggestionSelected, taxonomyPathString, filters, specialExercisePage = 0) {
    specialExercisePage++;
    if (!filters) {
        filters = {
            subjects: [],
            itemTypes: [],
            origins: [],
            favouriteOnly: false
        };
    }
    const { subjects, itemTypes, origins, favouriteOnly } = filters;
    return async dispatch => {
        dispatch({
            type: specialExercisePage === 1 ? types.GET_SPECIAL_EXERCISES : types.GET_MORE_SPECIAL_EXERCISES,
            filters: {
                subjects,
                itemTypes,
                origins,
                favouriteOnly
            },
            searchTerm,
            page: specialExercisePage,
            idList,
            isSuggestionSelected,
            taxonomyPathString
        });
        try {
            const {
                data: { data, totalCount }
            } = await axios.post(`${API_URL}/cv/getItemsByContentPaths`, {
                contentPath: idList,
                page: specialExercisePage,
                subjects: Array.isArray(subjects) && subjects.length > 0 ? parserUtils.getElementsFromArrayByProp('ids', subjects) : undefined,
                itemTypes: Array.isArray(itemTypes) && itemTypes.length > 0 ? parserUtils.getElementsFromArrayByProp('id', itemTypes) : undefined,
                origin:
                    Array.isArray(origins) && origins.length > 0
                        ? parserUtils.getElementsFromArrayByProp('id', origins)
                        : [originUtils.PROVE_COMUNI, originUtils.PROVE_INGRESSO, originUtils.REALTA_MODELLI],
                favourites: favouriteOnly
            });
            dispatch({
                type: specialExercisePage === 1 ? types.GET_SPECIAL_EXERCISES_SUCCESS : types.GET_MORE_SPECIAL_EXERCISES_SUCCESS,
                result: data.map(e => ({ ...fixExerciseStructure(e), contextId: getContextId(idList) })),
                totalCount,
                specialExercisePage,
                favourites: favouriteOnly
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            if (e.response && e.response.status === 401) {
                dispatch({
                    type: types.GET_SPECIAL_EXERCISES_UNAUTHORIZED,
                    error: 'Unauthorized'
                });
            } else {
                dispatch({
                    type: types.GET_SPECIAL_EXERCISES_FAILURE,
                    error:
                        'Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ricercare esercizi speciali. Si prega di riprovare più tardi.'
                });
            }
        }
    };
}

export function getSpecialHomeworksList(favouriteOnly = false, specialHomeworkPage = 0) {
    specialHomeworkPage++;
    const url = `${API_URL}/cv/homework/origin?originIdsStr=[7,8,9]&order=${JSON.stringify({ property: 'title', direction: 'ASC' })}`;
    return async dispatch => {
        dispatch({
            type: specialHomeworkPage === 1 ? types.GET_SPECIAL_HOMEWORKS_LIST : types.GET_MORE_SPECIAL_HOMEWORKS_LIST,
            payload: {
                favouriteOnly
            }
        });
        try {
            const {
                data: { data, totalCount }
            } = await axios.get(`${url}&page=${specialHomeworkPage}&favourite=${favouriteOnly}&etag=${Math.random() * 1000}`);
            dispatch({
                type: specialHomeworkPage === 1 ? types.GET_SPECIAL_HOMEWORKS_LIST_SUCCESS : types.GET_MORE_SPECIAL_HOMEWORKS_LIST_SUCCESS,
                payload: {
                    result: data,
                    totalCount,
                    specialHomeworkPage
                }
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            if (e.response && e.response.status === 401) {
                dispatch({
                    type: types.GET_SPECIAL_HOMEWORKS_LIST_UNAUTHORIZED,
                    error: 'Unauthorized'
                });
            } else {
                dispatch({
                    type: specialHomeworkPage === 1 ? types.GET_SPECIAL_HOMEWORKS_LIST_FAILURE : types.GET_MORE_SPECIAL_HOMEWORKS_LIST_FAILURE,
                    error:
                        'Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ricercare prove speciali. Si prega di riprovare più tardi.'
                });
            }
        }
    };
}

export function onSpecialFiltersChange(filters, searchIdList, searchTerm) {
    return dispatch => {
        dispatch({
            type: types.EXERCISES_SPECIAL_FILTERS_CHANGE,
            filters,
            searchIdList,
            searchTerm
        });
    };
}
